import { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import { QueryParams } from '@/types/query';
import { RequestedFormCompletion } from '@/types/requestedFormCompletion';
import ajax from '@/utils/ajax';

export const requestedFormCompletionRepository = {
  async getRequestedFormCompletionList({
    host,
    params
  }: {
    host: string;
    params: QueryParams;
  }): Promise<RequestedFormCompletion[]> {
    const path = '/api/dugout/requested_form_completions/';
    const response = await ajax.get({
      url: `${host}${path}`,
      params
    });

    return response.data;
  }
};

const RequestedFormCompletionRepository = () => {
  const { host } = useContext(AppContext);

  return {
    async getRequestedFormCompletionList(params: QueryParams): Promise<RequestedFormCompletion[]> {
      return requestedFormCompletionRepository.getRequestedFormCompletionList({ host, params });
    }
  };
};

export default RequestedFormCompletionRepository;
